import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import { getCategories, addCategory, updateCategory, deleteCategory } from './Helpers/categories';
import CategoryList from './CategoryList';
import CategoryForm from './CategoryForm';
import { Category } from '../CRUD/CampSites/types';



const CategoryManager = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const apiUrl = process.env.REACT_APP_API_URL ?? '';
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const fetchCategories = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error("Access token is missing");
    }
    const categories = await getCategories(apiUrl, token);
    setCategories(categories);
    setLoading(false);
  };

  useEffect(() => {
    
    if (!isAuthenticated) {
      navigate("/login");
    } else {
      fetchCategories();
    }
    
  }, [isAuthenticated, navigate]);

  const handleAddCategory = async (category: Category) => {
    await addCategory(apiUrl, category);
    fetchCategories();
  };

  const handleUpdateCategory = async (category: Category) => {
    await updateCategory(apiUrl, category);
    fetchCategories();
  };

  const handleDeleteCategory = async (id: number) => {
    await deleteCategory(apiUrl, id);
    fetchCategories();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
    
      <CategoryForm
        categories={categories}
        selectedCategory={selectedCategory}
        onAddCategory={handleAddCategory}
        onUpdateCategory={handleUpdateCategory}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        setSelectedCategory={setSelectedCategory}
      />
      <CategoryList
        categories={categories}
        onEditCategory={(category) => {
          setSelectedCategory(category);
          setIsEditing(true);
        }}
        onDeleteCategory={handleDeleteCategory}
      />
    </div>
  );
};

export default CategoryManager;